import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import gsap from "gsap";
import Navbar from "./Navbar";
import SiteMap from "./SiteMap";
import Footer from "./Footer";
import TemplatePage from "./pages/template/TemplatePage";

const useStyles = makeStyles((theme) => ({
  root: {
    visibility: "hidden",
    overflowX: "hidden",
  },
}));

function Content(props) {
  const pages = SiteMap();
  const contentRef = React.useRef();

  useEffect(() => {
    const content = contentRef.current;
    gsap.set(content, { autoAlpha: 1, duration: 0.1 });
  }, []);

  const classes = useStyles();

  return (
    <div ref={contentRef} className={classes.root}>
      <Navbar />
      <Routes>
        {pages.map(({ path, Component = TemplatePage }) => (
          <Route path={path} key={path} element={<Component />} />
        ))}
      </Routes>
      <Footer />
    </div>
  );
}

export default Content;
